import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { contact } from '@/content/et/contact';
import { site } from '@/content/et/site';
import styles from './SiteHeader.module.css';

const navItems = [
  { href: '/#teenused', label: site.nav.services },
  { href: '/?mode=tire#teenused', label: site.nav.pricing },
  { href: '/#brandid', label: site.nav.brands },
  { href: '/#kontakt', label: site.nav.contact },
];

/** Past this scroll offset the logo shrinks to the compact size */
const SCROLL_COMPACT_PX = 12;

export function SiteHeader() {
  const [compact, setCompact] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setCompact(window.scrollY > SCROLL_COMPACT_PX);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={[styles.header, compact ? styles.headerCompact : '']
        .filter(Boolean)
        .join(' ')}
    >
      <div className={styles.inner}>
        <Link to="/" className={styles.logo} aria-label={contact.brandName}>
          <img
            src="/images/logo.svg"
            alt={contact.legalName}
            className={styles.logoImg}
            width={140}
            height={48}
          />
        </Link>

        <nav className={styles.nav} aria-label="Põhinavigatsioon">
          {navItems.map((item) => (
            <a key={item.href} href={item.href} className={styles.navLink}>
              {item.label}
            </a>
          ))}
        </nav>
      </div>
    </header>
  );
}
